<template>
  <div>
  <b-container fluid class="page-header py-5 mb-5 text-center">
    <b-container class="py-5">
      <h1 class="display-3 text-white mb-3 animated slideInDown">Services</h1>

      <!-- Breadcrumb -->
      <b-breadcrumb
        class="animated slideInDown justify-content-center"
        :items="breadcrumbItems"
        aria-label="breadcrumb"
      >
        <template #item="{ item }">
          <span :class="['breadcrumb-item', item.active ? 'active text-white' : 'text-white']">
            <router-link v-if="item.to" :to="item.to" class="text-white">{{ item.text }}</router-link>
            <span v-else>{{ item.text }}</span>
          </span>
        </template>
      </b-breadcrumb>
    </b-container>
  </b-container>
 

   <!-- Include Experience component -->
  <ExperiencePage />
  <b-container class="py-5">
    <b-row>
      <b-col lg="4" class="mb-4">
        <div class="services-sidebar shadow-sm">
          <div 
            v-for="service in services" 
            :key="service.id"
            :class="['service-item', { active: activeService.id === service.id }]"
            @click="activeService = service"
          >
            {{ service.name }}
            <b-icon icon="chevron-right" class="float-end"></b-icon>
          </div>
        </div>
      </b-col>

      <b-col lg="8">
        <div class="service-content animated fadeIn">
          <b-img 
            :src="activeService.image" 
            fluid 
            class="mb-4 rounded shadow-sm service-main-img" 
            alt="Service Image"
          ></b-img>
          
          <h2 class="fw-bold mb-3">{{ activeService.name }}</h2>
          <p class="text-muted mb-4">{{ activeService.description }}</p>
          
          <h5 class="fw-bold mb-3">Key Features:</h5>
          <ul class="list-unstyled">
            <li v-for="(point, index) in activeService.points" :key="index" class="mb-2">
              <b-icon icon="check-circle-fill" class="text-danger me-2"></b-icon>
              {{ point }}
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>

<script>



export default {
  name: "ServicesPage",
  data() {
    const serviceData = [
      {
        id: 1,
        name: 'Protocol Service',
        description: 'We offer a wide range of services that can assess all security measures such as:',
        points: [
          'Arranging Airport pick up or drop off for clients at designated airports. We discuss with our clients and agree on a methodology for identification at the airport.',
          'Meet & Greet at both international and local Airports for both Nigerians and Expatriates.',
          'We liaise with the airport authorities to ensure that assistance is provided to the client while undergoing the various airport formalities.',
          'Air-conditioned and comfortable cars are provided for clients.',
          'Trainings and Seminars'
        ],
        image: require('@/assets/camera.jpg') // Use your actual asset path
      },
      {
        id: 2,
        name: 'Man Guarding',
        description: 'The company provides security cover for important social events such as Weddings, Launchings, Funerals, and Product Promotions.',
        points: [
          'Crowd Control and Traffic Management',
          'VIP Protection',
          'Access Control'
        ],
        image: require('@/assets/camera.jpg')
      },
      {
        id: 3,
        name: 'Security Consultancy',
        description: 'We offer a wide range of services that can assess all security measures such as:',
        points: [
          'Security Surveys and Risk Assessment',
          'Security Policy Formulations',
          'Background Checks/ Due Diligence',
          'Security Investigations',
          'Trainings and Seminars'
        ],
        image: require('@/assets/camera.jpg') // Use your actual asset path
      },
      {
        id: 4,
        name: 'Event Management',
        description: 'Our mobile units are coordinated by operators of our 24hr control room keeping them informed at all times.',
        points: [
          'versatility in traffic',
          'crowd control',
          'Intervention Services'
        ],
        image: require('@/assets/camera.jpg')
      },
      {
        id: 5,
        name: 'Mobile Response',
        description: 'Our mobile units are coordinated by operators of our 24hr control room keeping them informed at all times.Out of Hour Check visits: We are equipped to provide you with patrol services in unmanned premises by carrying out routine property checks.These patrol officers will carry out full site inspection as dictated by Client. This is mostly utilized by many for VOID PROPERTY INSPECTIONS (VPIs) Incident Response: The mobile patrol teams carry out random checks of all our manned sites and will react to all reported incidents on the sites.',
        points: [
          '24/7 Patrol and Monitoring',
          'Incident Response Teams',
          'Intervention Services'
        ],
        image: require('@/assets/camera.jpg')
      },
      {
        id: 6,
        name: 'Escort Service',
        description: 'Our mobile units are coordinated by operators of our 24hr control room keeping them informed at all times.',
        points: [
          '24/7 Patrol and Monitoring',
          'Incident Response Teams',
          'Intervention Services'
        ],
        image: require('@/assets/camera.jpg')
      },
      {
        id: 7,
        name: 'Electonic Security',
        description: 'We offer a wide range of services that can assess all security measures such as:',
        points: [
          'CCTV supply, installation and maintenance.',
          'Intruder and fire alarm systems.',
          'Radio and base station.',
          'Foldable walk through body scanner.',
          'Car Tracking Systems.'
        ],
        image: require('@/assets/camera.jpg')
      }
    ];

    return {
      breadcrumbItems: [
        { text: 'Home', to: '/' },
        { text: 'Services', to: '/service' }
      ],
      services: serviceData,
      activeService: serviceData[0]
    }
  }
}
</script>

<style scoped>
/* Header & Breadcrumb */
.page-header {
  background: linear-gradient(rgba(22, 22, 22, 0.7), rgba(22, 22, 22, 0.7)),
  url('@/assets/carousel_1.jpg') center center no-repeat;
  background-size: cover;
  font-family: 'Poppins', sans-serif;
}
.breadcrumb-item { font-size: 1rem; font-family: 'Poppins', sans-serif; }
.breadcrumb { background-color: transparent !important; padding: 0; margin: 0; }
.breadcrumb-item a { color: white !important; text-decoration: none; }
h1 { font-size: 3rem; font-family: 'Poppins', sans-serif; font-weight: bold; }

/* Sidebar Navigation */
.services-sidebar {
  background: #ffffff;
  border: 1px solid #eee;
  border-radius: 5px;
}
.service-item {
  padding: 15px 20px;
  cursor: pointer;
  font-weight: 600;
  border-bottom: 1px solid #f1f1f1;
  transition: all 0.3s ease;
  color: #333;
}
.service-item:last-child { border-bottom: none; }

/* Brand Red Hover & Active */
.service-item:hover, 
.service-item.active {
  background-color: #990000 !important;
  color: #ffffff !important;
}

/* Content Area */
.service-main-img {
  width: 100%;
  height: 350px;
  object-fit: cover;
}
.brand-red-text { color: #990000; }

/* Simple Animation */
.animated.fadeIn {
  animation-duration: 0.6s;
}
</style>
